import { DotLottie } from '@lottiefiles/dotlottie-web';

export default class Lottie {
  constructor() {
    this.init();
  }

  init() {
    const dotLottie = new DotLottie({
      autoplay: true,
      loop: false,
      canvas: document.querySelector('#dotlottie-canvas'),
      src: 'assets/lottie/typo.json', // or .json file
    });
  }
}
